import React, { useRef, useState } from 'react';

import { type TableDataRow } from 'src/utils/jmrUtils';

import ConflictingTasksPopover from './conflictingTasksPopover';

interface ConflictErrorBannerListItemProps {
  selectedJob: TableDataRow;
  exceededRestrictionIds: Set<number>;
  onClickJob: (jobId: string) => void;
}

/** This is a separate component to simplify tracking the popover anchor element and hover state. */
const ConflictErrorBannerListItem = ({
  selectedJob,
  exceededRestrictionIds,
  onClickJob,
}: ConflictErrorBannerListItemProps) => {
  const popoverAnchorRef = useRef<HTMLLIElement>(null);
  const [isPopoverOpen, setPopeverOpen] = useState(false);

  return (
    <li onMouseEnter={() => setPopeverOpen(true)} onMouseLeave={() => setPopeverOpen(false)}>
      {/* Meridian Link, Button, even standard anchor components were causing some wonky hover issue where
          hovering one entry and mousing over another would prevent the newly moused component from firing it's handlers
          for some reason, no matter how much you wiggle the mouse. Had to fall back decorating standard text.
          It may have something to do with Popovers autoFocusFirstFocusableElement defaulting to true but I ran out of
          time to test this further.
          See recording for example: 
          https://drive.corp.amazon.com/view/afrsharp@/bug-screenshots/hover-doesnt-work-input-and-anchor.mov */}
      <u
        onClick={() => {
          onClickJob(selectedJob.id);
        }}
        ref={popoverAnchorRef}
      >
        {selectedJob.name}
      </u>
      <ConflictingTasksPopover
        anchorRef={popoverAnchorRef}
        isOpen={isPopoverOpen}
        onClose={() => setPopeverOpen(false)}
        {...{ selectedJob, exceededRestrictionIds }}
      />
    </li>
  );
};

export default ConflictErrorBannerListItem;
